<template>
    <div>
        <ListPage
            :query="query"
            :total="total"
            v-loading="loading"
            :data="tableData"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            @search="handleSearch"
            @reset="resetQuery"
        >
            <template slot="filters">
                <el-form-item label="" prop="search_keyword">
                    <el-input v-model="query.search_keyword" placeholder="请输入商品标题进行搜索" clearable @keyup.enter.native="handleSearch" />
                </el-form-item>
            </template>
            <template slot="btns" v-if="permission('cpgl_tjlb_xz')">
                <el-button size="mini" type="primary" @click="handleAdd"> 新增 </el-button>
            </template>
            <template slot="columns">
                <el-table-column label="序号" align="center" prop="sort" />
                <el-table-column label="封面图" align="center">
                    <template slot-scope="{ row }">
                        <img @click="handlePreview(row.goods.cover_img)" v-if="row.goods && row.goods.cover_img" :src="ossUrl + row.goods.cover_img" width="50" />
                    </template>
                </el-table-column>
                <el-table-column label="商品标题" align="center" prop="goods.name" />
                <el-table-column label="更新时间" align="center" prop="update_time" />
                <el-table-column
                    v-if="permission('cpgl_tjlb_sy') || permission('cpgl_tjlb_xy') || permission('cpgl_tjlb_sc')"
                    label="操作"
                    align="center"
                    width="140"
                >
                    <template slot-scope="{ row, $index }">
                        <el-button v-if="showUp($index) && permission('cpgl_tjlb_sy')" size="mini" type="text" @click="handleUp(row)">
                            上移
                        </el-button>
                        <el-button v-if="showDown($index) && permission('cpgl_tjlb_xy')" size="mini" type="text" @click="handleDown(row)">
                            下移
                        </el-button>
                        <el-button v-if="permission('cpgl_tjlb_sc')" size="mini" type="text" @click="handleDel(row)"> 删除 </el-button>
                    </template>
                </el-table-column>
            </template>
        </ListPage>
        <FormVue ref="form" @update="search" />
		<PicPreviewer ref="preview"></PicPreviewer>
    </div>
</template>

<script>
import { list, del, up, down } from "@/api/product/recommend";
import listMixin from "@/mixins/list";
import { ossUrl } from "@/configs/oss";
import FormVue from "./form.vue";
import PicPreviewer from "@/components/PicPreviewer";

export default {
    components: { FormVue, PicPreviewer },
    data() {
        return {
            ossUrl,
            list,
            del,
            // 查询参数
            query: {
                search_keyword: "",
            },
            module: "产品推荐",
        };
    },
    mixins: [listMixin],
    mounted() {
        this.search();
    },
    methods: {
        search() {
            this._search();
        },
        showUp(index) {
            return index > 0 && index <= this.tableData.length - 1;
        },
        showDown(index) {
            return index < this.tableData.length - 1 && index >= 0;
        },
        handleAdd() {
            this.$refs.form.open();
        },
		handlePreview(url) {
            this.$refs.preview.open(url);
        },
        handleUp(row) {
            up({ uuid: row.uuid }).then(({ code, error }) => {
                if (code === 200) {
                    this.$message.success("上移成功");
                    this.search();
                } else {
                    this.$message.error(error.message);
                }
            });
        },
        handleDown(row) {
            down({ uuid: row.uuid }).then(({ code, error }) => {
                if (code === 200) {
                    this.$message.success("下移成功");
                    this.search();
                } else {
                    this.$message.error(error.message);
                }
            });
        },
    },
};
</script>
